/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useEffect } from 'react';
import { useAppData } from '@/hooks/useAppData';
import { sessionStorage } from '@/utils/sessionStorage';

/** Clears state(s), local and session storage items related to the sign-in success snackbar notification and password reset toast notification when a user signs out
 *
 * @param setIsResetPasswordToastNotificationOpen sets this state to false, closing the notification if a user signs out without doing so manually
 */
export function useResetSignInNotifications(
  setIsResetPasswordToastNotificationOpen: (value: boolean) => void,
) {
  const { appData } = useAppData();
  useEffect(() => {
    if (!appData.userAuthenticated) {
      sessionStorage.removeItem('isNewAccount');
      sessionStorage.removeItem('resetPasswordFrom');
      sessionStorage.removeItem('signInAlertShown');
      sessionStorage.removeItem('signInAlertDisabled');
      setIsResetPasswordToastNotificationOpen(false);
    }
  }, [appData.userAuthenticated, setIsResetPasswordToastNotificationOpen]);
}
